<template>
  <app-badge
    :size="size"
    :color="badgeColor"
    :outlined="isAgency && isIncoming"
    data-sentry-unmask
  >
    {{ badgeCopy }}
  </app-badge>
</template>

<script setup>
import { computed } from 'vue';
import {
  TransferStatusBadgeCopy,
  AgencyTransferStatusBadgeCopy,
  TransferStatus,
  TransferStatusBadgeColor,
} from '@/constants/transfers';

const props = defineProps({
  size: {
    type: String,
    default: 'sm',
  },
  status: {
    type: String,
    required: true,
  },
  isAgency: {
    type: Boolean,
    default: false,
  },
});

const badgeCopy = computed(() => {
  return props.isAgency ? AgencyTransferStatusBadgeCopy[props.status] : TransferStatusBadgeCopy[props.status];
});

const badgeColor = computed(() => {
  return TransferStatusBadgeColor[props.status];
});

const isIncoming = computed(() => {
  return props.status === TransferStatus.RELEASED;
});
</script>
